import employee_axios from "./employeeaxios";

 export const refreshToken = async () => {
    try {
      const resp = await employee_axios.post("/auth/refresh-tokens",{
        refreshToken: localStorage.getItem("rToken"),
      });
      console.log("refresh token", resp.data);
      
      return resp.data;
    } catch (e) {
      console.log("Error",e);   
    }
  };